import { brandConfig } from '@core-mkt/brands/ins/config';
import type { Env } from '@core-mkt/services/env/env';

export const environment: Env = {
  production: true,
  envMode: 'dev',
  adobeAnalytics: '',
  blogPrefix: 'resources--',
  enforceTrailingSlash: true,
  craftApiUrl: 'https://gqlproxy.ecom-stage.aceable.com/dev/api/',
  blogCraftApiUrl: 'https://gqlproxy.ecom-stage.aceable.com/blog-dev/api/',
  xgritCheckoutUrl: 'https://checkout-insurance.ecom-dev.aceable.com/checkout/',
  xgritApiConfig: {
    url: 'https://stg.xgritapi.com/api/1/',
    aceauth: 'Basic MDY5MGI2MDc4ZjBmNTUwOTJlMmFiZDNlMmY3ODk3Zjg6',
    baseParams: {
      appType: 'RE',
      platform: 'MKT',
      brandId: 'INS',
    },
  },
  defaultOgImage:
    'https://xgrit-ecom.imgix.net/v3_images/transforms/_350x89_crop_center-center_none/ace_ins_logo.svg?v=1730836120&auto=compress,format',
  optimizelyId: '2605830644',
  brandConfig,
  sentryDsn: 'https://73e707345a0f091ee0c4c1165a1cdd9c@o1007654.ingest.us.sentry.io/4508797243949056',
  segmentId: 'z50oXkPCtuhFKTUWoEeAAc78uWj4iJhC',
  segmentCdnProxy: 'sgprox.xgritapi.com',
  segmentApiProxy: 'sgapiprox.xgritapi.com',
  feefoMarchantId: '',
  twitterHandle: '',
  facebookDomainVerification: '',
  googleSiteVerification: 'YrnFWa0_O7Lyf9GVhk-ZrZDbst_WsLta_9hxzGKkPM0',
  wistiaVerification: 'Bearer f70f44da17d8dd9a2a09df5c84c1ea2ba9f23d1b5edea43f9a2862cfe1fc99fd',
  ipifyUrl: '',
  xccApiUrl: 'https://checkout-insurance-api.ecom-dev.aceable.com',
  gladlyHelpCenterEnvironment: {
    api: 'https://aceable.us-1.gladly.com',
    orgId: 'VJOTwOvcQ6WJr85bp0qL0g',
    brandId: 'iG8oR56lR16bXhIj8tteFg',
    cdn: 'https://cdn.gladly.com',
    selector: 'gladly-help-center',
  },
  overrideRobotsDirectives: null, // Use to override the robots value in the SEO data and set it as noindex, nofollow
  overrideCanonical: null, // Use to override the canonical value in the SEO data
  allowedHosts: {
    hosts: ['aceable.com'],
    trustedDomains: ['aceable.com'],
    reviewAppPatterns: ['^[\\w-]+\\.sandbox\\.aceable\\.com$'],
  },
};
